"use client";

import { useEffect, useState } from "react";

const DEFAULT_LOGO = "/logo.svg";
const DIWALI_LOGO = "/msu-happy-diwali.gif";

// Diwali logo is shown until 10 Nov 2026, 00:00 IST, then the default logo returns
const DIWALI_LOGO_END = new Date("2026-11-10T00:00:00+05:30").getTime();

const getHeaderLogo = () =>
  Date.now() < DIWALI_LOGO_END ? DIWALI_LOGO : DEFAULT_LOGO;

export default function useHeaderLogo() {
  const [logo, setLogo] = useState(getHeaderLogo);

  // Re-check on the client so statically built pages don't keep a stale logo
  useEffect(() => {
    setLogo(getHeaderLogo());
  }, []);

  return logo;
}
